module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"shared":{"go_to":{"company_profile":"Zum Firmenprofil","user":"Profil anzeigen"}}}}}')
  delete Component.options._Ctor
}
